<div class="form-alert" id="formAlertId" *ngIf="content?.errorCode">
  <idp-form-alert
    [showCloseButton]="true"
    [message]="content?.pageContent?.errors?.formAlertErrorMessage"
    (closePopup)="onClosePop()"
  ></idp-form-alert>
</div>

<idp-login-header
  [ngClass]="
    content?.sqaFormAttributes?.errorAlertBanner &&
    content?.sqaFormAttributes.submitAttempt
      ? 'login-header-margin'
      : ''
  "
  [loginHeaderContent]="content?.pageContent?.pageHeader"
></idp-login-header>
<ng-container
  *ngIf="
    content?.sqaFormAttributes?.submitAttempt &&
    content?.sqaFormAttributes?.errorAlertBanner &&
    content?.sqaFormAttributes?.errorCount
  "
>
  <idp-alert-warning
    #alertWarning
    (firstInvalidFieldFocusEvent)="onFocusFirstInvalidField()"
    [cntError]="content?.sqaFormAttributes?.errorCount"
    [errorMessage]="content?.pageContent?.errors?.alertWarningErrorMessages"
  ></idp-alert-warning>
</ng-container>
<ng-container *ngIf="content?.formGroup">
  <form
    [formGroup]="content?.formGroup"
    (ngSubmit)="submit()"
    class="loginFormSQA"
  >
    <div class="login-content-body">
      <div class="form-group questionContainer">
        <div>
          <span
            class="questionHeaderLabel"
            [innerHTML]="content?.pageContent?.question1Label"
          ></span>
        </div>

        <div class="questionContent">
          <span
            class="securityQuestion"
            [innerHTML]="
              content?.sqaStoredQuestionList?.securityQuestionList[0]
                ?.questionText
            "
          ></span>
        </div>

        <idp-input
          [labelTxt]="content?.pageContent?.answer1Label"
          (focusOut)="onFocussedOut('answer1')"
          formControlName="answer1"
          id="answer1"
          (value)="onChange()"
        ></idp-input>
        <div *ngIf="showErrorMessageQuestionOne" class="error-message__answer1">
          <span
            [innerHTML]="content?.pageContent?.errors?.answer1ErrorMessage"
          ></span>
        </div>
      </div>
      <div class="form-group questionContainer">
        <div>
          <span
            class="questionHeaderLabel"
            [innerHTML]="content?.pageContent?.question2Label"
          ></span>
        </div>
        <div class="questionContent">
          <span
            class="securityQuestion"
            [innerHTML]="
              content?.sqaStoredQuestionList?.securityQuestionList[1]
                ?.questionText
            "
          ></span>
        </div>
        <idp-input
          [labelTxt]="content?.pageContent?.answer2Label"
          formControlName="answer2"
          id="answer2"
          (value)="onChange()"
          (focusOut)="onFocussedOut('answer2')"
        ></idp-input>
        <div *ngIf="showErrorMessageQuestionTwo" class="error-message__answer2">
          <span
            [innerHTML]="content?.pageContent?.errors?.answer2ErrorMessage"
          ></span>
        </div>
      </div>

      <div class="recoverBySQA__cta--button">
        <idp-button
          [label]="content?.pageContent?.nextDisplayView?.button_modal"
          [size]="'full-width'"
          [elementType]="'submit'"
          [disabled]="content?.disableButton"
        ></idp-button>
      </div>
    </div>
  </form>
</ng-container>
